import { StripeError } from '@stripe/stripe-js'
import {
    CHECKOUT_FRAUD_BLOCK,
    CHECKOUT_PAYMENT_DECLINED,
} from '@/src/common/constants'
import { User } from 'firebase/auth'
import { sendCheckoutBlockedOrDeclinedFSEvent } from '@/src/common/utilities/fullstory/events'
import { sendBasicEvent } from '@/src/common/utilities/gtag'

function handleStripeError(
    error: StripeError,
    updateState: Function,
    user: User | null
) {
    const {
        decline_code,
        type,
        message,
        payment_intent,
        payment_method,
        code,
    } = error
    const declineReason =
        decline_code === 'fraudulent'
            ? CHECKOUT_FRAUD_BLOCK
            : CHECKOUT_PAYMENT_DECLINED

    sendBasicEvent(declineReason, {
        message,
        code,
        decline_code,
        amount: payment_intent?.amount,
    })
    sendCheckoutBlockedOrDeclinedFSEvent(
        declineReason,
        user,
        {
            message,
            code,
            decline_code,
            payment_email: payment_method?.billing_details?.email,
            payment_phone: payment_method?.billing_details?.phone,
        },
        payment_intent?.amount
    )

    if (['card_error', 'invalid_request_error'].includes(type)) {
        return updateState({ paymentMessage: message })
    }

    const isValidationError = type == 'validation_error'
    return updateState({
        paymentMessage: isValidationError
            ? ''
            : 'An unexpected error occurred.',
    })
}

export default handleStripeError
